import React, { useRef, useState } from "react";

const CustomScrollMenu = ({ items, selectedId, onSelect ,id}) => {
    const scrollRef = useRef();
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 1; // Scroll speed factor
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUpOrLeave = () => {
        setIsDragging(false);
    };

    return (
        <div
            ref={scrollRef}
            className="hide-scrollbar"
            style={{
                padding:"10px",
                display: "flex",
                overflowX: "auto",
                whiteSpace: "nowrap",
                gap: "10px",
                cursor: isDragging ? "grabbing" : "grab",
                userSelect: "none"
            }}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUpOrLeave}
            onMouseLeave={handleMouseUpOrLeave}
        >
            {items.map((tag) => (
                <div
                   className="btn btn-grey "
                    key={tag[id]}
                    onClick={() => onSelect(tag[id])}
                    style={{
                       
                        backgroundColor: selectedId === tag[id] ? "#75f" : "#292929",
                        
                    }}
                >
                    {tag.tag_title}
                </div>
            ))}
        </div>
    );
};

export default CustomScrollMenu;
